import React from 'react';
import {connect} from "react-redux";
import CustomAppBarPublic from '../utils/CustomAppBarPublic';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';


class LastPosts extends React.Component {

    constructor(props) {
        super(props);
        this.getLastPosts = this.getLastPosts.bind(this);
        this.state = {posts: [], isFetched: false};
    }

    getLastPosts() {
        axios.get('https://cms.monentretienpro.fr/wp-json/wp/v2/posts')
            .then(x => this.setState({isFetched: true, posts: x.data}));
    }


    render() {
        this.getLastPosts();
        return <div>
            <CustomAppBarPublic/>

            <div className='container'>
                <h2 className="text-center" style={{paddingTop: 20}}>Derniers articles</h2><br/>
                <ul className="row justify-content-md-center">
                    {
                        this.state.isFetched ?
                            this.state.posts.map(p =>
                                <li><a href={p.link}
                                       dangerouslySetInnerHTML={{__html: p.title.rendered}}/>
                                </li>)
                            : <CircularProgress size={80} thickness={5}/>
                    }
                </ul>
            </div>
        </div>;
    }
}

function mapStateToProps(store) {
    return {open: store.shared.drawer.open}
}

export default connect(mapStateToProps)(LastPosts);


// WEBPACK FOOTER //
// ./src/components/shared/pages/LastPosts.js